<template>
  <footer class="py-10 bg-gray-900 dark:bg-gray-950 text-white relative overflow-hidden transition-colors duration-500">
    <!-- Top accent -->
    <div class="absolute top-0 left-0 right-0 h-px bg-gray-800 dark:bg-gray-800"></div>

    <div class="max-w-5xl mx-auto px-6">
      <div class="flex flex-col md:flex-row justify-between items-center gap-6">
        <!-- Brand -->
        <Link href="/" class="group flex items-center gap-2.5">
          <span class="w-8 h-8 rounded-lg bg-amber-500 group-hover:bg-amber-600 transition-colors flex items-center justify-center shrink-0">
            <span class="text-white font-extrabold font-mono text-xs tracking-tight">pvm</span>
          </span>
          <span class="text-sm font-semibold text-gray-400 font-mono group-hover:text-gray-300 transition-colors">pvpmartins</span>
        </Link>

        <!-- Nav links -->
        <nav class="flex gap-8">
          <Link href="/articles" class="text-gray-400 hover:text-white transition-colors text-sm font-medium">{{ t('articles') }}</Link>
          <button @click="scrollToSection('#about')" class="text-gray-400 hover:text-white transition-colors text-sm font-medium">{{ t('about') }}</button>
          <button @click="scrollToSection('#contact')" class="text-gray-400 hover:text-white transition-colors text-sm font-medium">{{ t('contact') }}</button>
        </nav>

        <!-- Social links -->
        <div class="flex gap-3">
          <a href="https://github.com/pvpmartins" target="_blank" class="w-10 h-10 rounded-xl bg-gray-800/80 dark:bg-gray-800/80 flex items-center justify-center text-gray-400 hover:bg-gray-700 hover:text-white transition-all border border-gray-700/50 hover:border-gray-600">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
          </a>
          <a href="https://linkedin.com/in/pvpmartins" target="_blank" class="w-10 h-10 rounded-xl bg-gray-800/80 dark:bg-gray-800/80 flex items-center justify-center text-gray-400 hover:bg-gray-700 hover:text-white transition-all border border-gray-700/50 hover:border-gray-600">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
        </div>
      </div>

      <!-- Divider -->
      <div class="my-6 border-t border-gray-800/50 dark:border-gray-800/50"></div>

      <!-- Copyright -->
      <div class="text-center text-gray-500 text-sm font-medium">
        © {{ new Date().getFullYear() }} Paulo Vitor. {{ t('craftedWithPassion') }}
      </div>
    </div>
  </footer>
</template>

<script setup>
import { Link, usePage, router } from '@inertiajs/vue3'
import { useI18n } from '@/i18n'

const { t } = useI18n()
const page = usePage()

// Handle hash navigation - scroll if on home page, navigate otherwise
const scrollToSection = (hash) => {
  const isHomePage = page.component === 'Home'
  
  if (isHomePage) {
    const element = document.querySelector(hash)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
      history.pushState(null, '', hash)
    }
  } else {
    router.visit(`/${hash}`)
  }
}
</script>
